var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboardCard"},[_c('h4',{attrs:{"id":"title"}},[_c('a',{attrs:{"href":_vm.dashboardCardContent.route}},[_vm._v(" "+_vm._s(_vm.dashboardCardContent.title)+" ")])]),_c('div',{staticClass:"dashboardCardContent"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }